const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const stripHtml = (value) => String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }

  const raw = await response.text().catch(() => '');
  if (raw) {
    try {
      const body = JSON.parse(raw);
      throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
    } catch {
      const plainText = stripHtml(raw);
      const detailMatch = plainText.match(/"detail"\s*:\s*"([^"]+)"/i);
      const message = detailMatch?.[1] || plainText;
      if (message) {
        throw new Error(message);
      }
    }
  }

  throw new Error(defaultMessage || `Request failed (${response.status})`);
};

export async function fetchRatioTrend(companyId, startPeriodId, endPeriodId, maxPeriods = 12, basis = 'IFRS') {
  const params = new URLSearchParams({
    companyId: String(companyId),
    startPeriodId: String(startPeriodId),
    endPeriodId: String(endPeriodId),
    maxPeriods: String(maxPeriods),
    basis: String(basis || 'IFRS')
  });

  const response = await fetch(`${API_BASE}/api/analysis/ratio-trend?${params.toString()}`, {
    headers: buildHeaders()
  });

  return handleErrors(response, 'Rasyo trend verisi alinamadi.');
}

const analysisRatioTrendService = {
  fetchRatioTrend
};

export default analysisRatioTrendService;
